import React, { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Portfolio } from "@/components/site/Portfolio";
import { Materials } from "@/components/site/Materials";
import { Sectors } from "@/components/site/Sectors";
import { Trust, Confidentiality } from "@/components/site/Trust";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";
import { useSeo } from "@/hooks/useSeo";
import { SectionHead } from "@/components/site/Portfolio";

const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28 ${className}`}>
    {children}
  </section>
);

export default function Home() {
  useSeo({
    title: "AxioForm 3D | Impressão e Fabrico 3D de Precisão em Portugal",
    description:
      "Serviço de impressão e fabrico 3D de alta precisão em Portugal. Prototipagem rápida e produção de peças finais (FDM, SLA, SLS). Envie o seu ficheiro 3D e receba orçamento em menos de 2h úteis.",
    path: "/",
  });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <div className="min-h-screen bg-ax-bg">
      <Navbar />
      <Hero />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-8 pb-4">
        <Trust />
      </section>

      <Section id="orcamento">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="font-mono text-xs uppercase tracking-widest text-ax-cyan">Pedir orçamento</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-ax-text mt-3">
            Envie a sua ideia / ficheiro
          </h2>
          <p className="text-ax-sub mt-4 leading-relaxed">
            Carregue o ficheiro 3D, descreva o que precisa e nós respondemos com uma proposta. Sem sair da página, sem email.
          </p>
        </div>
        <QuoteForm />
      </Section>

      <Section id="portfolio" className="border-t border-ax-border/60">
        <Portfolio />
      </Section>

      <Section id="materiais" className="border-t border-ax-border/60">
        <Materials />
      </Section>

      <Section id="setores" className="border-t border-ax-border/60">
        <Sectors />
      </Section>

      <Section id="confidencialidade" className="border-t border-ax-border/60">
        <Confidentiality />
      </Section>

      <Section id="faq" className="border-t border-ax-border/60">
        <Faq />
        <div className="mt-16 bg-gradient-to-br from-ax-orange/15 to-ax-card border border-ax-orange/30 rounded-2xl p-8 sm:p-12 text-center">
          <h3 className="font-heading text-2xl sm:text-3xl font-bold text-ax-text">Pronto para produzir a sua peça?</h3>
          <p className="text-ax-sub mt-3 max-w-xl mx-auto">Envie o seu ficheiro agora e receba uma proposta em menos de 2 horas úteis.</p>
          <button
            data-testid="footer-cta"
            onClick={() => document.getElementById("orcamento")?.scrollIntoView({ behavior: "smooth" })}
            className="mt-6 inline-flex items-center gap-2 bg-ax-orange hover:bg-ax-orangehover text-white font-semibold px-7 py-3.5 rounded-lg transition-all hover:scale-[1.03] hover:ax-glow"
          >
            Envie a sua ideia / ficheiro
          </button>
        </div>
      </Section>

      <Footer />
      <WhatsAppFab />
    </div>
  );
}
